'use client';

import { useEffect } from 'react';
import confetti from 'canvas-confetti';

interface ConfettiCelebrationProps {
  trigger: boolean;
  duration?: number;
}

export function ConfettiCelebration({ trigger, duration = 3000 }: ConfettiCelebrationProps) {
  useEffect(() => {
    if (!trigger) return;

    // Fire confetti from multiple angles
    const end = Date.now() + duration;
    const colors = ['#00843D', '#FFD600', '#4ADE80', '#10B981'];

    const frame = () => {
      confetti({
        particleCount: 2,
        angle: 60,
        spread: 55,
        origin: { x: 0 },
        colors: colors
      });
      
      confetti({
        particleCount: 2,
        angle: 120,
        spread: 55,
        origin: { x: 1 },
        colors: colors
      });

      if (Date.now() < end) {
        requestAnimationFrame(frame);
      }
    };

    // Start the animation
    frame();

    // Also fire a burst in the center
    confetti({
      particleCount: 100,
      spread: 70,
      origin: { y: 0.6 },
      colors: colors
    });

  }, [trigger, duration]);

  return null;
}